// axios
import axios from 'axios'
import store from './store/store'
import _ from 'lodash'

//const domain = "/api/";
//const domain = "https://optima.innvectra.in/api/";
//const domain = "https://deepvisioncs.innvectra.in/api/";
//const domain = 'http://localhost:8989'
//const domain = 'https://52.8.133.242/api/'
const domain = "https://support.kinara.ai/api/";


const instance = axios.create({
  baseURL: domain
  // You can add your headers here
})


instance.interceptors.request.use(function (config) {
  console.log('tokenDetailss', store.state)
  // alert(JSON.stringify(store.state))
  const token = store.state.auth.token
  if (token != null) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, function (err) {
  return Promise.reject(err)
})

instance.interceptors.response.use(
  function(response){     
    return response;
  }, 
  function(error){
      // handle error LOGIN_USER_INACTIVE
      let err = _.cloneDeep(error);
     
      if(error && _.has(error,'response' ) && _.has(error.response ,"data" ) && _.has(error.response.data ,"result" ) && _.has(error.response.data.result ,"error_message" ) &&  _.has(error.response.data.result.error_message ,"code" )  ){
        
        if(error.response.data.result.error_message.code =='LOGIN_USER_INACTIVE' ){
          localStorage.removeItem('token');
          localStorage.removeItem('userRole');
          localStorage.removeItem('user');
          localStorage.removeItem('LS_ROUTE_KEY');
          store.dispatch('auth/logout');
          window.location.reload();
          //this.showToster({message:'sdhsdhfdsf',isError:true})
         // alert(error.response.data.result.error.code)
         
         
        }
       
      }
          
      return Promise.reject(error);
      //return error;
  });


export default instance
